import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'bold'
})
export class BoldPipe implements PipeTransform {

  constructor(
    private sanitizer: DomSanitizer
  ) {}

  transform(str: string, nonBoldExpression?: string): any {
    const positions = nonBoldExpression ? this.match(str, nonBoldExpression) : [];

    if (positions.length > 0) {
      let charsToBold = '';
      positions.map(([min, max]) => {
        charsToBold = `</b>${str.substring(min, max)}<b>`;
        str = str.substring(0, min) + charsToBold + str.substring(max, str.length);
      });
    }

    str = `<b>${str}</b>`;

    // replace `<b> </b>` with a whitespace ' '
    str = str.replace(
      new RegExp('<b> </b>', 'gi'),
      ' '
    );

    // clean str from empty <b></b> tags and sanitize it
    return this.sanitize(
      str.replace(
        new RegExp('<b></b>', 'gi'),
        ''
      )
    );
  }

  replace(str: string, word: string) {
    // replace every word in str with </b>word<b>
    return str.replace(
      new RegExp(word, 'i'),
      '</b>$&<b>'
    );
  }

  sanitize(str) {
    return this.sanitizer.sanitize(SecurityContext.HTML, str);
  }

  escapeRegexCharacters(str) {
    const specialCharsRegex = /[.*+?^${}()|[\]\\]/g;
    return str.replace(specialCharsRegex, '\\$&');
  }

  match(text, query) {
    const wordCharacterRegex = /[a-z0-9_]/i;
    const whitespacesRegex = /\s+/;

    return (
      query
        .trim()
        .split(whitespacesRegex)
        // In case query is empty we filter it out
        .filter(word => {
          return word.length > 0;
        })
        .reduce((result, word) => {
          const wordLen = word.length;
          const prefix = wordCharacterRegex.test(word[0]) ? '\\b' : '';
          const regex = new RegExp(prefix + this.escapeRegexCharacters(word), 'i');
          const index = text.search(regex);

          if (index > -1) {
            result.push([index, index + wordLen]);

            // Replace what we found with spaces so we don't find it again.
            text =
              text.slice(0, index) +
              new Array(wordLen + 1).join(' ') +
              text.slice(index + wordLen);
          }

          return result;
        }, [])
        .sort(function(match1, match2) {
          return match2[0] - match1[0];
        })
    );
  }
}
